import { useEffect, useState } from "react";
import useACSClient from "./useACSClient";
import { getPresenceStateLabel } from "../../common/utils";

export function usePresence() {
  const [presence, setPresence] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const client = useACSClient();

  const resetToOldState = () => {
    let oldPs = localStorage.getItem('activePS');
    oldPs = oldPs ? JSON.parse(oldPs) : {};
    if(oldPs && oldPs.availability && oldPs.activity) {
      setPresence({
        availability: oldPs.availability,
        activity: oldPs.activity,
        graph: (oldPs.graph ? oldPs.graph : null),
      });
    }
  }

  useEffect(() => {
    let intervalId;

    async function loadPresence() {
      try {
        const result = await getPresenceStateLabel(); 
        //let result = {success:false, message:"err"}; //for testing
        if (!result.success) {
          setError(result.message || result.error || "Unknown error");
          console.error('error : ' + error);
          resetToOldState();
        } else {
          const newPresence = {
            availability: result.availability,
            activity: result.activity,
            graph: result.graph,
          }
          setPresence(newPresence);
          localStorage.setItem('activePS', JSON.stringify(newPresence));
        }
      } catch (err) {
        setError(err.message || "Unknown error");
      } finally {
        setLoading(false);
      }
    }

    // initial call
    loadPresence();

    // repeat every 10s
    intervalId = setInterval(loadPresence, 10000);

    // cleanup on unmount
    return () => clearInterval(intervalId);

  }, []);//client -> else rerun on each change

  const setPresenceState = async (state) => {
    try {
      setPresence({availability: state, activity: state, graph: null,});
      const result = await client.setPresenceInTeamsClient(state);
      //let result = {success:false, message:"err"}; //for testing
      if (!result.success) {
        setError(result.message || result.error || "Failed to update presence");
        console.error('error : ' + error);
        resetToOldState();
      } else {
        // update local presence state after successful set
        /*setPresence({
          availability: result.availability,
          activity: result.activity,
          graph: result.graph,
        });
        localStorage.setItem('activePS', JSON.stringify(result));*/ //let getPs update cache
      }

      return result;
    } catch (err) {
      setError(err.message);
      return { success: false, message: "Exception", error: err.message };
    }
  };

  return { presence, loading, error, setPresenceState };
}
